import { STUDIO_REFERRER } from 'src/constants/studioFtux';

// Keep this a string. Importing PLAN_PAGE loads the sidebar icon graph into
// onboarding and switcher tests that mock aws-amplify incompletely.
const PLANS_PAGE_PATH = '/settings/plans';

export const ADDITIONAL_WORKSPACE_PLAN_PARAM = 'additionalWorkspace';

export const additionalWorkspacePlansPath = (): string =>
  `${PLANS_PAGE_PATH}?${ADDITIONAL_WORKSPACE_PLAN_PARAM}=1`;

/** Home of the free workspace, with the upgrade modal open. */
export const additionalWorkspaceHomePath = (): string =>
  `/?${ADDITIONAL_WORKSPACE_PLAN_PARAM}=1`;

/**
 * Studio home (`/`) immediately redirects to the first sidebar item. Keep the
 * upgrade-modal query on that hop so the modal still opens.
 */
export const carryAdditionalWorkspaceQuery = (path: string): string => {
  if (
    typeof window === 'undefined' ||
    new URLSearchParams(window.location.search).get(
      ADDITIONAL_WORKSPACE_PLAN_PARAM,
    ) !== '1'
  ) {
    return path;
  }
  const url = new URL(path, window.location.origin);
  url.searchParams.set(ADDITIONAL_WORKSPACE_PLAN_PARAM, '1');
  return `${url.pathname}${url.search}${url.hash}`;
};

const isLocalDevHost = (hostname: string): boolean =>
  hostname === 'localhost' ||
  hostname === '127.0.0.1' ||
  hostname.endsWith('.localhost');

/**
 * Opens the free workspace on this webapp and shows the upgrade modal.
 * Localhost stays on localhost. A different public host uses that portal's site.
 */
/** Studio login URL that signs into the free workspace and opens the modal. */
export const freePortalLoginUrl = ({
  email,
  magicLink,
  portalId,
}: {
  email: string;
  magicLink: string;
  portalId: string;
}): string => {
  const next = `/portal/${encodeURIComponent(portalId)}?next=${encodeURIComponent(additionalWorkspaceHomePath())}`;
  const params = new URLSearchParams({
    referrer: STUDIO_REFERRER,
    email,
    magic_link: magicLink,
    next,
  });
  return `/login?${params.toString()}`;
};

export const freePortalEntryUrl = (
  portalId: string,
  portalUrl: string,
): string => {
  const path = `/portal/${encodeURIComponent(portalId)}?next=${encodeURIComponent(additionalWorkspaceHomePath())}`;
  if (
    typeof window === 'undefined' ||
    isLocalDevHost(window.location.hostname)
  ) {
    return path;
  }
  if (!portalUrl) {
    return path;
  }
  try {
    const target = new URL(portalUrl);
    if (target.host === window.location.host) {
      return path;
    }
    return `${target.origin}${path}`;
  } catch {
    return path;
  }
};

export const isAdditionalWorkspacePlanVisit = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return (
    new URLSearchParams(window.location.search).get(
      ADDITIONAL_WORKSPACE_PLAN_PARAM,
    ) === '1'
  );
};
